export const IMAGES = {
    palace: [
        "https://images.pexels.com/photos/20418514/pexels-photo-20418514.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        "https://images.pexels.com/photos/34669540/pexels-photo-34669540.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        "https://images.unsplash.com/photo-1720754096019-d4330e022d97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3ZWRkaW5nJTIwcGFsYWNlJTIwZ29sZCUyMHJveWFsJTIwYXJjaGl0ZWN0dXJlJTIwYXJjaCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzkyODM3MDc0fDA&ixlib=rb-4.1.0&q=85",
    ],
    peacock: [
        "https://images.pexels.com/photos/33549674/pexels-photo-33549674.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        "https://images.pexels.com/photos/35985364/pexels-photo-35985364.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    decor: [
        "https://images.unsplash.com/photo-1728051063621-5adc06f09267?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBmbG93ZXJzJTIwbWFyaWdvbGQlMjBtYW5kYXAlMjByb3lhbCUyMGxpZ2h0c3xlbnwwfHx8fDE3OTI4MzcwODF8MA&ixlib=rb-4.1.0&q=85",
        "https://images.unsplash.com/photo-1728051063561-90cdbd7cce65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3ZWRkaW5nJTIwZGVjb3IlMjBmbG93ZXJzJTIwbWFyaWdvbGQlMjBtYW5kYXAlMjByb3lhbCUyMGxpZ2h0c3xlbnwwfHx8fDE3OTI4MzcwODF8MA&ixlib=rb-4.1.0&q=85",
    ],
};

export const COUPLE = {
    groom: "Sarthak",
    bride: "Tanishka",
    groomLineage: [
        "Grandson of Late Smt. Bimla Devi & Late Shri Malik Ram Alagh",
    ],
    brideLineage: ["Daughter of Smt. Pooja Tuli & Shri Kamal Tuli"],
    dateDisplay: "Sunday, 22nd November 2026",
    weddingIso: "2026-11-22T18:30:00+05:30",
};

export const CHOWKI = {
    invocation: "॥ जय माता दी ॥",
    title: "Mata Ki Chowki",
    date: "Saturday, 14th November 2026",
    time: "7:00 PM — 10:00 PM",
    after: "Followed by Dinner",
    venue: "Casa Royal Banquets",
    address: "C-102, Industrial Area, Phase-II, Mayapuri, New Delhi — 110064",
    mapsUrl: "https://maps.google.com/?q=Casa+Royal+Banquets+Mayapuri+Phase+II+New+Delhi",
};

export const WEDDING = {
    invocation: "॥ श्री गणेशाय नमः ॥",
    title: "The Royal Wedding",
    date: "Sunday, 22nd November 2026",
    venue: "Wedding Opera",
    address: "B-9, Britannia Chowk, Lawrence Road, Delhi",
    mapsUrl: "https://maps.google.com/?q=Wedding+Opera+Britannia+Chowk+Lawrence+Road+Delhi",
    programme: [
        {
            time: "6:30 PM",
            name: "Sehra Bandhi",
            location: "RL 38, Ganga Ram Vatika, Tilak Nagar, New Delhi — 110018",
        },
        {
            time: "8:00 PM",
            name: "Baraat Reassembles",
            location: "Wedding Opera, B-9, Britannia Chowk, Lawrence Road, Delhi",
        },
        {
            time: "10:00 PM",
            name: "Royal Dinner",
            location: "Wedding Opera",
        },
    ],
};

export const FAMILIES = ["Alagh", "Oberoi", "Chopra", "Monga", "Wason", "Kapoor"];

export const PHONES = [
    { label: "Alagh Family", number: "+91 98715 43377", tel: "+919871543377", wa: "919871543377" },
    { label: "Alagh · Oberoi", number: "+91 98996 88717", tel: "+919899688717", wa: "919899688717" },
    { label: "Chopra · Monga", number: "+91 96541 09970", tel: "+919654109970", wa: "919654109970" },
    { label: "Wason · Kapoor", number: "+91 85880 92209", tel: "+918588092209", wa: "918588092209" },
];

export const PHOTOS = [
    {
        src: "https://customer-assets-lqy194kg.emergentagent.net/job_grand-vows/artifacts/04b2703a67529229_5521.jpg",
        alt: "Sarthak and Tanishka selfie in matching pink outfits",
        caption: "Two hearts, one frame",
    },
    {
        src: "https://customer-assets-lqy194kg.emergentagent.net/job_grand-vows/artifacts/30ecacebddac5494_21669.webp",
        alt: "Sarthak and Tanishka looking out over a mountain valley together",
        caption: "Every horizon, together",
    },
    {
        src: "https://customer-assets-lqy194kg.emergentagent.net/job_grand-vows/artifacts/0e906d678ec16052_5647.jpg",
        alt: "Sarthak and Tanishka in matching pink outfits amid festive decor",
        caption: "Amidst the festivities",
    },
];

export const MATA_RANI_IMG = "/assets/mata-rani.png";

export const WEDDING_OPERA_IMG =
    "https://images.pexels.com/photos/14646749/pexels-photo-14646749.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const MAP_EMBEDS = {
    chowki: "https://www.google.com/maps?q=Casa+Royal+Banquets,+C-102,+Industrial+Area,+Phase-II,+Mayapuri,+New+Delhi+110064&output=embed",
    wedding: "https://www.google.com/maps?q=Wedding+Opera,+B-9,+Britannia+Chowk,+Lawrence+Road,+Delhi&output=embed",
};

export const INVITE_MESSAGE =
    "॥ श्री गणेशाय नमः ॥\n\nWith immense joy, the Alagh & Tuli families invite you to the wedding of Sarthak & Tanishka — Sunday, 22nd November 2026, Wedding Opera, Delhi. Mata Ki Chowki: Saturday, 14th November 2026, Casa Royal Banquets, Mayapuri. Your gracious presence and blessings will make our celebration truly memorable.";

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.6 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const downloadAllIcs = () => {
    const ics = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//SarthakTanishka//Wedding//EN",
        "BEGIN:VEVENT",
        "UID:sarthak-tanishka-chowki-2026@royalwedding",
        "DTSTAMP:20260701T000000Z",
        "DTSTART:20261114T133000Z",
        "DTEND:20261114T163000Z",
        "SUMMARY:Mata Ki Chowki — Sarthak & Tanishka",
        "LOCATION:Casa Royal Banquets\\, C-102\\, Industrial Area\\, Phase-II\\, Mayapuri\\, New Delhi 110064",
        "DESCRIPTION:7:00 PM to 10:00 PM\\, followed by Dinner.",
        "END:VEVENT",
        "BEGIN:VEVENT",
        "UID:sarthak-tanishka-wedding-2026@royalwedding",
        "DTSTAMP:20260701T000000Z",
        "DTSTART:20261122T130000Z",
        "DTEND:20261122T170000Z",
        "SUMMARY:Sarthak weds Tanishka — The Royal Wedding",
        "LOCATION:Wedding Opera\\, B-9\\, Britannia Chowk\\, Lawrence Road\\, Delhi",
        "DESCRIPTION:Sehra Bandhi 6:30 PM at Ganga Ram Vatika\\, Tilak Nagar. Baraat 8:00 PM at Wedding Opera. Dinner 10:00 PM.",
        "END:VEVENT",
        "END:VCALENDAR",
    ].join("\r\n");
    const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Sarthak-Tanishka-Celebrations.ics";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
};
